import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { POLICIES } from './policyContent';
import LegalPageShell from './LegalPageShell';

const SLUG_BY_PATH = {
  '/terms': 'terms',
  '/privacy': 'privacy',
  '/refund-policy': 'refund',
  '/cancellation-policy': 'cancellation',
  '/service-delivery-policy': 'shipping',
  '/contact': 'contact',
  '/pricing': 'pricing',
  '/grievance': 'grievance',
};

const VALID_SLUGS = Object.keys(POLICIES);

export default function LegalPolicyPage({ slug: slugProp } = {}) {
  const { pathname } = useLocation();
  const slug = slugProp || SLUG_BY_PATH[pathname];
  const policy = slug ? POLICIES[slug] : null;

  if (!policy || !VALID_SLUGS.includes(slug)) {
    return (
      <LegalPageShell title="Page not found" meta="">
        <p style={{ color: '#8896a8' }}>Policy not found.</p>
        <Link to="/login" style={{ color: '#c9a84c' }}>← Back to Development Express</Link>
      </LegalPageShell>
    );
  }

  return (
    <LegalPageShell title={policy.title} meta={`Last updated: June 2026`} slug={slug}>
      {policy.sections.map((sec) => (
        <section key={sec.heading} style={{ marginBottom: '20px' }}>
          <h2 style={h2}>{sec.heading}</h2>
          <p style={body}>{sec.body}</p>
        </section>
      ))}
    </LegalPageShell>
  );
}

const h2 = { color: '#c9a84c', fontSize: '14px', margin: '0 0 8px' };
const body = { color: '#b8c0cc', fontSize: '13px', margin: 0, whiteSpace: 'pre-line' };
